import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { Button } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './engineBoxButton.js';


class EngineBoxButton extends React.Component {
  static displayName = 'EngineBoxButton';

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };
  constructor(props) {
    super(props);
    this.cx = props.theme.bind();
  }

  showElements = (btnIcon, btnText) => {

    const { config, theme } = this.props;

    const {
      selectedSearch,
      start,
      end,
      executeSearch,
    } = config;
    const { classes } = theme.styles

    return <Button
        onClick={executeSearch}
        rightIcon={{
          unicodeContent: btnIcon,
          innerStyle: [classes.searchIcon, this.cx({DESK: !this.isMobile()})]
        }}
        innerStyle={['toggleMainButton', classes.searchButton, this.cx({'disabled':!selectedSearch || !start || !end})]}
        id='td-search-00'
        richText={{
          ucFirst: true,
          text: btnText,
          translate: true,
          innerStyle: [classes.searchText]
        }}
        tabIndex={0}/>

  }

  render() {
    const { config, theme } = this.props;

    const {
      dropDown,
      showModalView,
      visibleType,
      closeModalView,
      engineMerged,
      modalBreak
    } = config;
    const { classes } = theme.styles

    //Desktop version
    if(!modalBreak){
      const btnIcon = 'e086';
      const btnText = '_%buscar%_';
      return <div className={[theme.computedInnerStyle,  this.cx({ engineMerged: engineMerged })].join(' ')} tabIndex={0}>
        <div className={classes.buttonContainer}>
          {this.showElements(btnIcon, btnText)}
        </div>
      </div>
    }

    //Mobile version
    if(!dropDown){
      const btnIcon = 'e086';
      const btnText = !showModalView ? '' : '_%buscar%_';
      return <div className={[theme.computedInnerStyle, this.cx({dispoModal:showModalView})].join(' ')} tabIndex={0}>
        <div className={classes.buttonContainer}>
          {this.showElements(btnIcon, btnText)}
        </div>
      </div>
    }

    if(visibleType === 'occups' && dropDown){
      return <div className={[theme.computedInnerStyle, this.cx({dispoModal:showModalView})].join(' ')} tabIndex={0}>
        <div className={classes.buttonContainer}>
          <Button
            onClick={closeModalView}
            rightIcon={{ unicodeContent: 'e086', innerStyle: classes.searchIcon }}
            innerStyle={['toggleMainButton', classes.searchButton]}
            richText={{ ucFirst: true, text: '_%aceptar%_', translate: true }}
            tabIndex={0}
          />
        </div>
      </div>
    }

    return <></>
  }
}

export default compose(
  PropertyManager([
    'classes',
    'dropDown',
    'selectedSearch',
    'start',
    'end',
    'showModalView',
    'visibleType',
    'executeSearch',
    'closeModalView',
    'engineMerged',
    'modalBreak'
  ]),
  withThemeJSS({ styleFile, link: true, index: 100 }),
  withContent('i18n')
)(EngineBoxButton);
